<div class="legal">
  <H1>TERMS OF USE</H1>
  <p><i>Last Updated: June 30, 2020</i></p>
  <p>IMPORTANT NOTICE: THIS AGREEMENT IS SUBJECT TO BINDING ARBITRATION AND A WAIVER OF CLASS ACTION RIGHTS AS DETAILED
    IN SECTION 13. PLEASE READ THE AGREEMENT CAREFULLY.</p>

  <H4>1. Acceptance of terms</H4>
  <p>Kukai Wallet (hereinafter “Kukai,” “we,” “us,” or “our”) provides a platform for managing Tezos accounts, and
    allowing ordinary websites and applications to interact with the blockchain network, while keeping the user in
    control over what transactions they approve, through our website located at https://kukai.app/ (the “Site”), which
    includes text, images, audio, code and other materials (collectively, the “Content”) and all of the features, and
    services provided. The Site and any other features, tools, materials, or other services offered from time to time by
    Kukai Wallet are referred to here as the “Services.” Please read these Terms of Use (the “Terms”) carefully before
    using the Services. By using or otherwise accessing the Services, or clicking to accept or agree to these Terms
    where that option is made available, you (1) accept and agree to these Terms, (2) consent to the collection, use,
    disclosure and other handling of information as described in our Privacy Policy and (3) agree to any additional
    terms, rules and conditions of participation issued by Kukai Wallet from time to time. If you do not agree to any of
    the Terms, then you may not access or use the Content or Services.</p>

  <H4>2. Modification of Terms of Use</H4>
  <p>Except for Section 13, providing for arbitration and waiver of class action rights, Kukai Wallet reserves the
    right, at its sole discretion, to modify or replace the Terms at any time without notice. We will always try to
    provide advance notice, however, we reserve the right to modify or replace the Terms at our discretion. The most
    current version of these Terms will be posted on our Site. You shall be responsible for reviewing and becoming
    familiar with any such modifications. Use of the Services by you after any modification to the Terms constitutes
    your acceptance of the Terms as modified.</p>

  <H4>3. Eligibility</H4>
  <p>You hereby represent and warrant that you are fully able and competent to enter into the terms, conditions,
    obligations, affirmations, representations and warranties set forth in these Terms and to abide by and comply with
    these Terms.</p>

  <p>Kukai Wallet is a global platform and by accessing the Content or Services, you are representing and warranting
    that you are of the legal age of majority in your jurisdiction as is required to access such Services and Content
    and enter into arrangements as provided by the Services. You further represent that you are otherwise legally
    permitted to use the service in your jurisdiction including owning cryptographic tokens of value, and interacting
    with the Services or Content in any way. You further represent you are responsible for ensuring compliance with the
    laws of your jurisdiction and acknowledge that Kukai Wallet is not liable for your compliance with such laws.</p>

  <p>In addition, you represent to us that you and your financial institutions, or any party that owns or controls you
    or your financial institutions, are (1) not subject to sanctions or otherwise designated on any list of prohibited
    or restricted parties, including but not limited to the lists maintained by the United Nations Security Council, the
    U.S. Government (e.g., the Specially Designated Nationals List and Foreign Sanctions Evaders List of the U.S.
    Department of Treasury and the Entity List of the U.S. Department of Commerce), the European Union or its Member
    States, or other applicable government authority and (2) not located in any country to which the United States has
    embargoed goods or has otherwise applied any sanctions.</p>

  <H4>4. Account Password and Security</H4>
  <p>When setting up an account within Kukai Wallet, you will be responsible for keeping your own account secrets, which
    may be a word seed phrase, an account file, or other locally stored secret information. Kukai Wallet encrypts this
    information locally with a password you provide, that we never send to our servers. You agree to (a) never use the
    same password for Kukai Wallet that you have ever used outside of this service, (b) keep your secret information and
    password confidential and do not share them with anyone else and (c) immediately notify Kukai Wallet of any
    unauthorized use of your account or breach of security. Kukai Wallet cannot and will not be liable for any loss or
    damage arising from your failure to comply with this section.

  <H4>5. DISCLAIMERS- RISKS</H4>

  <H5>5.1. Warranty Disclaimer</H5>
  <p>You expressly understand and agree that your use of the Services is at your sole risk. The Services (including the
    Site and the Content) are provided on an “as is” and “as available” basis, without warranties of any kind, either
    express or implied, including, without limitation, implied warranties of merchantability, fitness for a particular
    purpose or non-infringement. You acknowledge that Kukai Wallet has no control over, and no duty to take any action
    regarding: which users gain access to or use the Services; what effects the Content may have on you; how you may
    interpret or use the Content; or what actions you may take as a result of having been exposed to the Content. You
    release Kukai Wallet from any and all liability for you having acquired or not acquired Content through the
    Services. Kukai Wallet makes no representations concerning any Content contained in or accessed through the
    Services, and Kukai Wallet will not be responsible or liable for the accuracy, copyright compliance, legality or
    decency of material contained in or accessed through the Services.</p>

  <p>We do not represent or warrant that access to the Services will be continuous, uninterrupted, timely or secure. You
    acknowledge and accept that the Services (a) may contain bugs, errors and defects, (b) may function improperly or be
    subject to periods of downtime and unavailability, (c) may result in total or partial loss or corruption of data and
    (d) may be modified at any time, including through the release of subsequent versions, all with or without notice to
    you.</p>

  <p>You acknowledge that Kukai Wallet is not responsible for transferring, safeguarding, or maintaining your private
    keys or any digital currency associated therewith. If you lose, mishandle or have stolen associated digital currency
    private keys, you acknowledge that you may not be able to recover associated digital currency, and that Kukai Wallet
    is not responsible for such loss. You acknowledge that Kukai Wallet is not responsible for any loss, damage or
    liability arising from your failure to comply with the terms hereunder.</p>

  <H5>5.2 Sophistication and Risk of Cryptographic Systems</H5>
  <p>By utilizing the Services or interacting with the Content or platform in any way, you represent that you understand
    the inherent risks associated with cryptographic systems; and warrant that you have an understanding of the usage
    and intricacies of the native cryptographic token Tezos (xtz), smart contract based tokens, and blockchain-based
    software systems.</p>

  <H5>5.3 Risk of Regulatory Actions in One or More Jurisdictions</H5>
  <p>Kukai Wallet and any supported cryptographic token and blockchain could be impacted by one or more regulatory
    inquiries or regulatory action, which could impede or limit the ability of Kukai Wallet to continue to develop, or
    which could impede or limit your ability to access or use the Services or the underlying blockchain network.</p>

  <H5>5.4 Risk of Weaknesses or Exploits in the Field of Cryptography</H5>
  <p>You acknowledge and understand that Cryptography is a progressing field. Advances in code cracking or technical
    advances such as the development of quantum computers may present risks to cryptocurrencies and Services of Content,
    which could result in the theft or loss of your cryptographic tokens or property. To the extent possible, Kukai
    Wallet intends to update the protocol underlying Services to account for any advances in cryptography and to
    incorporate additional security measures, but does not guarantee or otherwise represent full security of the system.
    By using the Services or accessing Content, you acknowledge these inherent risks.</p>

  <H5>5.5 Volatility of Cryptocurrencies</H5>
  <p>You understand that Tezos and other blockchain technologies and associated cryptographic tokens are highly volatile
    due to many factors including but not limited to adoption, speculation, technology and security risks. You also
    acknowledge that the cost of transacting on such technologies is variable and may increase at any time causing
    impact to any activities taking place on the blockchain network. You acknowledge these risks and agree that Kukai
    Wallet cannot be held liable for such fluctuations or increased costs.</p>

  <H5>5.6 Application Security</H5>
  <p>You further acknowledge that blockchain applications are code subject to flaws and acknowledge that you are solely
    responsible for evaluating any code provided by the Services or Content and the trustworthiness of any third-party
    websites, products, smart-contracts, or Content you access or use through the Services. You further expressly
    acknowledge and represent that blockchain applications can be written maliciously or negligently, that Kukai Wallet
    cannot be held liable for your interaction with such applications and that such applications may cause the loss of
    property or even identity. This warning and others later provided by Kukai Wallet in no way evidence or represent an
    on-going duty to alert you to all of the potential risks of utilizing the Services or Content. The code to Kukai
    Wallet can be found at: https://github.com/kukai-wallet/kukai.</p>

  <H4>6. Indemnity</H4>
  <p>You agree to release and to indemnify, defend and hold harmless Kukai Wallet and its principles, subsidiaries,
    affiliates and agencies, as well as the officers, directors, employees, shareholders and representatives of any of
    the foregoing entities, from and against any and all losses, liabilities, expenses, damages, costs (including
    attorneys’ fees and court costs) claims or actions of any kind whatsoever arising or resulting from your use of the
    Services, your violation of these Terms, and any of your acts or omissions that implicate publicity rights,
    defamation or invasion of privacy, and privacy laws. Kukai Wallet reserves the right, at its own expense, to assume
    exclusive defense and control of any matter otherwise subject to indemnification by you and, in such case, you agree
    to cooperate with Kukai Wallet in the defense of such matter.</p>

  <H4>7. Limitation on Liability</H4>
  <p>YOU ACKNOWLEDGE AND AGREE THAT YOU ASSUME FULL RESPONSIBILITY FOR YOUR USE OF THE SITE AND THE SERVICES. YOU
    ACKNOWLEDGE AND AGREE THAT ANY INFORMATION YOU SEND OR RECEIVE DURING YOUR USE OF THE SITE AND THE SERVICES MAY NOT
    BE SECURE AND MAY BE INTERCEPTED OR LATER ACQUIRED BY UNAUTHORIZED PARTIES. YOU ACKNOWLEDGE AND AGREE THAT YOUR USE
    OF THE SITE AND THE SERVICES IS AT YOUR OWN RISK. RECOGNIZING SUCH, YOU UNDERSTAND AND AGREE THAT, TO THE FULLEST
    EXTENT PERMITTED BY APPLICABLE LAW, NEITHER KUKAI WALLET NOR ITS SUPPLIERS OR LICENSORS WILL BE LIABLE TO YOU FOR
    ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE, EXEMPLARY OR OTHER DAMAGES OF ANY KIND,
    INCLUDING WITHOUT LIMITATION DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER TANGIBLE OR INTANGIBLE LOSSES
    OR ANY OTHER DAMAGES BASED ON CONTRACT, TORT, STRICT LIABILITY OR ANY OTHER THEORY (EVEN IF KUKAI WALLET HAD BEEN
    ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), RESULTING FROM THE SITE OR SERVICES; THE USE OR THE INABILITY TO USE
    THE SITE OR THE SERVICES; UNAUTHORIZED ACCESS TO OR ALTERATION OF YOUR TRANSMISSIONS OR DATA; STATEMENTS OR CONDUCT
    OF ANY THIRD PARTY ON THE SITE OR THE SERVICES; ANY ACTIONS WE TAKE OR FAIL TO TAKE AS A RESULT OF COMMUNICATIONS
    YOU SEND TO US; HUMAN ERRORS; TECHNICAL MALFUNCTIONS; FAILURES, INCLUDING PUBLIC UTILITY OR TELEPHONE OUTAGES;
    OMISSIONS, INTERRUPTIONS, LATENCY, DELETIONS OR DEFECTS OF ANY DEVICE OR NETWORK, PROVIDERS, OR SOFTWARE (INCLUDING,
    BUT NOT LIMITED TO, THOSE THAT DO NOT PERMIT PARTICIPATION IN THE SERVICES); ANY INJURY OR DAMAGE TO COMPUTER
    EQUIPMENT; INABILITY TO FULLY ACCESS THE SITE OR THE SERVICES OR ANY OTHER WEBSITE; THEFT, TAMPERING, DESTRUCTION,
    OR UNAUTHORIZED ACCESS TO, IMAGES OR OTHER CONTENT OF ANY KIND; DATA THAT IS PROCESSED LATE OR INCORRECTLY OR IS
    INCOMPLETE OR LOST; TYPOGRAPHICAL, PRINTING OR OTHER ERRORS, OR ANY COMBINATION THEREOF; OR ANY OTHER MATTER
    RELATING TO THE SITE OR ANY OTHER ASPECT OF THE SERVICES.</p>

  <p>SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN WARRANTIES OR THE LIMITATION OR EXCLUSION OF LIABILITY FOR
    INCIDENTAL OR CONSEQUENTIAL DAMAGES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS MAY NOT APPLY TO YOU.</p>

  <H4>8. Intellectual Property</H4>
  <H5>8.1 Our Proprietary Rights</H5>
  <p>All title, ownership and intellectual property rights in and to the Services are owned by Kukai Wallet or its
    licensors. You acknowledge and agree that the Services contains proprietary and confidential information that is
    protected by applicable intellectual property and other laws. Except as expressly authorized by Kukai Wallet, you
    agree not to copy, modify, rent, lease, loan, sell, distribute, perform, display or create derivative works based on
    the Site, or the Services, in whole or in part.</p>

  <H5>8.2 Limited License</H5>
  <p>We grant you limited, non-exclusive, revocable permission to make use of the Site, and the Services (collectively
    referred to as, “Access”). This Access shall remain in effect until and unless terminated by you or us. You promise
    and agree that you will not redistribute or transfer the Services.</p>

  <p>The Kukai Wallet software application, including without limitation the Site, and the Services, are not sold or
    transferred to you, and Kukai Wallet and its licensors retain ownership of all copies of the software applications
    even after installation on your personal computers, mobile handsets, tablets, wearable devices, speakers and/or
    other devices (“Devices”).</p>

  <p>All Kukai Wallet trademarks, service marks, trade names, logos, domain names, and any other features of the Kukai
    Wallet brand (“Kukai Wallet Brand Features”) are the sole property of Kukai Wallet or its licensors. The Terms do
    not grant you any rights to use any Kukai Wallet Brand Features whether for commercial or non-commercial use.</p>

  <p>You agree to abide by our user guidelines and not to use the Services or any part thereof in any manner not
    expressly permitted by the Terms. Except for the rights expressly granted to you in the Terms, Kukai Wallet grants
    no right, title, or interest to you in the Site or the Services.</p>

  <p>Third party software (for example, open source software libraries) included in the Services are made available to
    you under the relevant third party software library’s license terms.</p>

  <p>Notwithstanding anything herein to the contrary, nothing in the Terms entitles you to copy, modify, fork, merge,
    combine with another program or create a derivative work of the Services, including without limitation the Site.</p>

  <H4>9. Links</H4>
  <p>The Services provide, or third parties may provide, links to other World Wide Web or accessible sites, applications
    or resources. Because Kukai Wallet has no control over such sites, applications and resources, you acknowledge and
    agree that Kukai Wallet is not responsible for the availability of such external sites, applications or resources,
    and does not endorse and is not responsible or liable for any content, advertising, products or other materials on
    or available from such sites or resources. You further acknowledge and agree that Kukai Wallet shall not be
    responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in
    connection with use of or reliance on any such content, goods or services available on or through any such site or
    resource.</p>

  <H4>10. Termination and Suspension</H4>
  <p>Kukai Wallet may terminate or suspend all or part of the Services and your Kukai Wallet access immediately, without
    prior notice or liability, if you breach any of the terms or conditions of the Terms. Upon termination of your
    access, your right to use the Services will immediately cease.</p>

  <p>The following provisions of the Terms survive any termination of these Terms: INDEMNITY; WARRANTY DISCLAIMERS;
    LIMITATION ON LIABILITY; OUR PROPRIETARY RIGHTS; LINKS; TERMINATION; NO THIRD PARTY BENEFICIARIES; BINDING
    ARBITRATION AND CLASS ACTION WAIVER; GENERAL INFORMATION.</p>

  <H4>11. No Third Party Beneficiaries</H4>
  <p>You agree that, except as otherwise expressly provided in these Terms, there shall be no third party beneficiaries
    to the Terms.</p>

  <H4>12. Notice and Procedure For Making Claims of Copyright Infringement</H4>
  <p>If you believe that your copyright or the copyright of a person on whose behalf you are authorized to act has been
    infringed, please provide Kukai Wallet’s Copyright Agent a written Notice containing the following information:</p>

  <p>- an electronic or physical signature of the person authorized to act on behalf of the owner of the copyright or
    other intellectual property interest;
    <BR>- a description of the copyrighted work or other intellectual property that you claim has been infringed;
    <BR>- a description of where the material that you claim is infringing is located on the Services;
    your address, telephone number, and email address;
    <BR>- a statement by you that you have a good faith belief that the disputed use is not authorized by the copyright
    owner, its agent, or the law;
    <BR>- a statement by you, made under penalty of perjury, that the above information in your Notice is accurate and
    that you are the copyright or intellectual property owner or authorized to act on the copyright or intellectual
    property owner’s behalf.</p>

  <p>Kukai Wallet’s Copyright Agent can be reached at:</p>

  <p>Email: legal@kukai.app</p>

  <H4>13. Binding Arbitration and Class Action Waiver</H4>

  <p>PLEASE READ THIS SECTION CAREFULLY – IT MAY SIGNIFICANTLY AFFECT YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A
    LAWSUIT IN COURT</p>

  <H5>13.1 Initial Dispute Resolution</H5>

  <p>The parties shall use their best efforts to engage directly to settle any dispute, claim, question, or disagreement
    and engage in good faith negotiations which shall be a condition to either party initiating a lawsuit or
    arbitration.</p>

  <H5>13.2 Binding Arbitration</H5>

  <p>If the parties do not reach an agreed upon solution within a period of 30 days from the time informal dispute
    resolution under the Initial Dispute Resolution provision begins, then either party may initiate arbitration as the
    sole means to resolve all claims, subject to the terms set forth below. Specifically, all claims arising out of or
    relating to these Terms (including their formation, performance and breach), the parties’ relationship with each
    other and/or your use of the Services shall be finally settled by binding arbitration administered by the American
    Arbitration Association in accordance with the provisions of its Commercial Arbitration Rules and the supplementary
    procedures for consumer related disputes of the American Arbitration Association (the “AAA”), excluding any rules or
    procedures governing or permitting class actions.</p>

  <p>The arbitrator, and not any federal, state or local court or agency, shall have exclusive authority to resolve all
    disputes arising out of or relating to the interpretation, applicability, enforceability or formation of these
    Terms, including, but not limited to any claim that all or any part of these Terms are void or voidable, or whether
    a claim is subject to arbitration. The arbitrator shall be empowered to grant whatever relief would be available in
    a court under law or in equity. The arbitrator’s award shall be written, and binding on the parties and may be
    entered as a judgment in any court of competent jurisdiction.</p>

  <p>The parties understand that, absent this mandatory provision, they would have the right to sue in court and have a
    jury trial. They further understand that, in some instances, the costs of arbitration could exceed the costs of
    litigation and the right to discovery may be more limited in arbitration than in court.</p>

  <H5>13.3 Location</H5>

  <p>Binding arbitration shall take place in Louisiana. You agree to submit to the personal jurisdiction of any federal
    or state court in Orleans Parish, Louisiana, in order to compel arbitration, to stay proceedings pending
    arbitration, or to confirm, modify, vacate or enter judgment on the award entered by the arbitrator.</p>

  <H5>13.4 Class Action Waiver</H5>

  <p>The parties further agree that any arbitration shall be conducted in their individual capacities only and not as a
    class action or other representative action, and the parties expressly waive their right to file a class action or
    seek relief on a class basis. YOU AND KUKAI WALLET AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR
    OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE
    PROCEEDING. If any court or arbitrator determines that the class action waiver set forth in this paragraph is void
    or unenforceable for any reason or that an arbitration can proceed on a class basis, then the arbitration provision
    set forth above shall be deemed null and void in its entirety and the parties shall be deemed to have not agreed to
    arbitrate disputes.</p>

  <H5>13.5 Exception - Litigation of Intellectual Property and Small Claims Court Claims</H5>

  <p>Notwithstanding the parties’ decision to resolve all disputes through arbitration, either party may bring an action
    in state or federal court to protect its intellectual property rights (“intellectual property rights” means patents,
    copyrights, moral rights, trademarks, and trade secrets, but not privacy or publicity rights). Either party may also
    seek relief in a small claims court for disputes or claims within the scope of that court’s jurisdiction.</p>

  <H5>13.6 Choice of Law</H5>

  <p>The Terms and the relationship between you and Kukai Wallet shall be governed by the laws of the State of Louisiana
    without regard to conflict of law provisions.</p>

  <H4>14. GENERAL INFORMATION</H4>

  <H5>14.1 Entire Agreement</H5>

  <p>These Terms (and any additional terms, rules and conditions of participation that Kukai Wallet may post on the
    Services) constitute the entire agreement between you and Kukai Wallet with respect to the Services and supersedes
    any prior agreements, oral or written, between you and Kukai Wallet. In the event of a conflict between these Terms
    and the additional terms, rules and conditions of participation, the latter will prevail over the Terms to the
    extent of the conflict.</p>

  <H5>14.2 Waiver and Severability of Terms</H5>

  <p>The failure of Kukai Wallet to exercise or enforce any right or provision of the Terms shall not constitute a
    waiver of such right or provision. If any provision of the Terms is found by an arbitrator or court of competent
    jurisdiction to be invalid, the parties nevertheless agree that the arbitrator or court should endeavor to give
    effect to the parties’ intentions as reflected in the provision, and the other provisions of the Terms remain in
    full force and effect.</p>

  <H5>14.3 Statute of Limitations</H5>

  <p>You agree that regardless of any statute or law to the contrary, any claim or cause of action arising out of or
    related to the use of the Services or the Terms must be filed within one (1) year after such claim or cause of
    action arose or be forever barred.</p>

  <H5>14.4 Section Titles</H5>

  <p>The section titles in the Terms are for convenience only and have no legal or contractual effect.</p>

  <H5>14.5 Communications</H5>

  <p>Users with questions, complaints or claims with respect to the Services may contact us using the relevant contact
    information set forth above or email us at: contact@kukai.app</p>
</div>